function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="footer-sections flex space-between">
                    <div>
                        <p className="footer-section-title">Company info</p>
                        <p><a src='#'>About Cartsy</a></p>
                        <p><a src='#'>Candian Supply</a></p>
                        <p><a src='#'>Chains Act Report</a></p>
                        <p><a src='#'>Supplier Code of Conduct</a></p>
                        <p><a src='#'>Conduct</a></p>
                        <p><a src='#'>Careers</a></p>
                        <p><a src='#'>Student Discount</a></p>
                    </div>
                    <div>
                        <p className="footer-section-title">Help and support</p>
                        <p><a src='#'>Shipping Info</a></p>
                        <p><a src='#'>Free Returns</a></p>
                        <p><a src='#'>How to Order</a></p>
                        <p><a src='#'>How To Track</a></p>
                        <p><a src='#'>Returns</a></p>
                    </div>
                    <div>
                        <p className="footer-section-title">Customer care</p>
                        <p><a src='#'>Contact Us</a></p>
                        <p><a src='#'>Payment Method</a></p>
                        <p><a src='#'>Bonus Points</a></p>
                        <p><a src='#'>Recalls</a></p>
                    </div>
                                    <div>
                        <p className="footer-section-title">Social media</p>
                        <p><a src='#'>Facebook</a></p>
                        <p><a src='#'>X</a></p>
                        <p><a src='#'>Instagram</a></p>
                    </div>
                </div>
            </div>
            <p className="copyright">2025 &copy; Cartsy.com. All Rights Reserved.</p>
        </footer>
    );
}

export default Footer;